import { SafeZone } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface SafeZoneInput {
  name: string;
  radius: number;
  center_coordinates?: string | null;
}

export const safeZoneService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<SafeZone>>("/safe_zone", {
      params: {
        page: page,
        per_page: per_page,
        search: search,
        ...filters,
      },
    });
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<SafeZone, false>>(
      `/safe_zone/${id}`,
    );
    return response.data;
  },

  async create(data: SafeZoneInput) {
    const response = await api.post("/safe_zone", {
      name: data.name,
      radius: data.radius,
      center_coordinates: data.center_coordinates,
    });
    return response.data;
  },

  async update(id: number | string, data: SafeZoneInput) {
    const response = await api.put(`/safe_zone/${id}`, {
      name: data.name,
      radius: data.radius,
      center_coordinates: data.center_coordinates,
    });
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/safe_zone/${id}`);
    return response.data;
  },
};
